import { createFileRoute } from '@tanstack/react-router';
import { JourneysCampaignsWelcomeHandoff } from '@/pages/workspaces/automations/routing';
import { AppBundle } from '@/utils/app-bundles';
import { LastWorkspaceResolver } from './-components';

/**
 * The legacy `/journeys/campaigns/welcome` URL. Flag off the embedded app serves it; flag on it
 * forwards to the migrated URL.
 */
function JourneysCampaignsWelcomeRoute() {
  return (
    <LastWorkspaceResolver appBundle={AppBundle.Journeys}>
      <JourneysCampaignsWelcomeHandoff page="welcome" />
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/journeys/campaigns/welcome/')({
  component: JourneysCampaignsWelcomeRoute,
});
